import React from 'react'
import { Table } from 'antd'

class CashRegisterTable extends React.Component {
  constructor(props, context) {
    super(props, context)
  }

  render() {
    const columns = [
      {
        title: 'Селлер ID',
        dataIndex: 'idnum',
        key: 'idnum',
        sorter: (a, b) => parseInt(a.idnum || 0) - parseInt(b.idnum || 0),
      },
      {
        title: 'Название селлера',
        dataIndex: 'seller_name',
        key: 'seller_name',
        sorter: (a, b) => (a.seller_name || '').localeCompare(b.seller_name || ''),
      },
      {
        title: 'Торговая точка',
        dataIndex: 'point_name',
        key: 'point_name',
        sorter: (a, b) => (a.point_name || '').localeCompare(b.point_name || ''),
      },
      {
        title: 'Уникальный ID кассы',
        dataIndex: 's_kkm',
        key: 's_kkm',
        sorter: (a, b) => (a.s_kkm || '').localeCompare(b.s_kkm || ''),
      },
      {
        title: 'Количество чеков',
        dataIndex: 'cntCheck',
        key: 'cntCheck',
        sorter: (a, b) => parseInt(a.cntCheck || 0) - parseInt(b.cntCheck || 0),
      },
      {
        title: 'Количество касс в разрезе селлера',
        dataIndex: 'seller_s_kkm_count',
        key: 'seller_s_kkm_count',
        sorter: (a, b) => parseInt(a.seller_s_kkm_count || 0) - parseInt(b.seller_s_kkm_count || 0),
      },
    ]

    return (
      <Table
        rowKey={record => `cash-register-row-${record.idnum}-${record.s_kkm}-${record.point_name}`}
        columns={columns}
        {...this.props}
      />
    )
  }
}

export default CashRegisterTable


// WEBPACK FOOTER //
// src/containers/Dashboard/CashRegisterStat/Table.jsx